import React from 'react';
import { Navigate } from 'react-router-dom';

const AdministratorRoute = ({ children }) => {
  const roles = (sessionStorage.getItem('groups') !== 'undefined' && JSON.parse(sessionStorage.getItem('groups'))) || [];

  const isAdmin = roles.includes('Admin') || roles.includes('Application Administrator');

  return isAdmin ? children : <Navigate to="/login" replace />;
};

export default AdministratorRoute;
